import React from "react";

import { ImageUpload } from "../BuilderUtils";
import MapViewEditor from "../MapViewEditor";
import { backgroundFieldOf } from "../pageKinds";
import { normalizeContextContent } from "../../explanation_pages/contextLayouts";

/**
 * LE DÉCOR DE LA PAGE : une image, ou la carte du territoire.
 *
 * Les deux ne cohabitent pas. Dès qu'une carte est allumée derrière la page,
 * elle occupe tout le fond : l'image ne serait plus visible nulle part, et
 * continuer à la proposer laisserait croire qu'elle sert encore. Le champ
 * disparaît donc au lieu d'être proposé en vain.
 */
export default function BackgroundInspector({ page, onPatch, onPatchContent, ctx }) {
  const { token, territories, pageTerritory } = ctx;
  const bgField = backgroundFieldOf(page.type);
  const mapIsOn = !!page.map_view?.mode && page.map_view.mode !== "off";
  // Le format « plein cadre » fait de son propre visuel le décor de la page :
  // l'image de fond passerait dessous, invisible. Même raison que pour la carte.
  const coverIsOn =
    page.type === "context" &&
    normalizeContextContent(page.content).layout === "cover" &&
    !!page.content?.media_url;

  return (
    <>
      {mapIsOn ? (
        <p className="step-editor-section-hint">
          La carte du territoire occupe le fond de cette page : une image de fond
          n'y serait pas visible. Repassez la carte sur « aucune » pour en poser une.
        </p>
      ) : coverIsOn ? (
        <p className="step-editor-section-hint">
          Le format « plein cadre » fait du visuel de la page son décor : il
          occupe déjà tout le fond. L'image de fond ne servirait que si ce visuel
          venait à manquer — elle se règle depuis l'onglet Contenu.
        </p>
      ) : (
        <div style={{ marginBottom: 20 }}>
          <ImageUpload
            label="Image de fond"
            value={page.content?.[bgField] || ""}
            onChange={(url) => onPatchContent({ [bgField]: url })}
            token={token}
          />
        </div>
      )}

      <MapViewEditor
        value={page.map_view || null}
        onChange={(v) => onPatch({ map_view: v })}
        territories={territories}
        pageTerritory={pageTerritory}
      />
    </>
  );
}
